import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';

export default class AccountBillingDetailsService {
    static getPolicyBillingSummary(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingData'), 'getPolicyBillingSummary', [policyNumber], additionalHeaders);
    }

    static getPaymentSummaryForPolicy_EY(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingData'), 'getPaymentSummaryForPolicy_EY', [policyNumber], additionalHeaders);
    }
}
